import type { UseQueryOptions } from "@tanstack/react-query";
import { useQuery } from "@tanstack/react-query";

import useApi from "$src/core/hooks/use-api";
import type { ProfileDto } from "$src/core/models/dto";

export const queryKey = () => ["profiles"];

const useProfilesQuery = (
  options?: Omit<
    UseQueryOptions<Awaited<ProfileDto[]>>,
    "queryKey" | "queryFn"
  >,
) => {
  const { api } = useApi();

  return useQuery({
    queryKey: queryKey(),
    queryFn: () => api.getProfiles(),
    ...options,
  });
};

export default useProfilesQuery;
